import { useEffect, useState } from 'react';

interface ShareBarProps {
  title: string;
}

const shareTargets = [
  { icon: 'ri-link', label: '复制链接' },
  { icon: 'ri-weibo-line', label: '分享到微博' },
  { icon: 'ri-wechat-line', label: '分享到微信' },
  { icon: 'ri-qq-line', label: '分享到 QQ' },
];

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(() => setToast(''), 2200);
    return () => clearTimeout(timer);
  }, [toast]);

  const handleShare = (label: string) => {
    if (label === '复制链接') {
      const url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).catch(() => undefined);
      }
      setToast('链接已复制（演示分享，未连接第三方平台）');
      return;
    }
    setToast(`${label} · 演示分享，敬请期待真实分享接口`);
  };

  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-foreground-500">分享：</span>
        {shareTargets.map((target) => (
          <button
            key={target.label}
            type="button"
            onClick={() => handleShare(target.label)}
            aria-label={target.label}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className={target.icon}></i>
          </button>
        ))}
        <button
          type="button"
          disabled
          className="ml-1 inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-400"
        >
          <i className="ri-heart-3-line"></i>
          点赞（演示）
        </button>
      </div>

      <p className="mt-2 text-xs text-foreground-400">
        当前为前端模拟分享，仅用于演示交互效果。
      </p>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 animate-fade-up rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50 shadow-lg">
          <span className="inline-flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            {toast}
          </span>
        </div>
      )}

      <span className="sr-only" aria-live="polite">
        {title}
      </span>
    </>
  );
}